import {
  useMutation
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query'
import {
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  BackendErrorEntity,
  PostSellIntentBodyDto,
  SellIntentEntity
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType, BodyType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiPostSellIntent = (
    postSellIntentBodyDto: MaybeRef<PostSellIntentBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      postSellIntentBodyDto = unref(postSellIntentBodyDto);
      
      return fetchApiInstance<SellIntentEntity>(
      {url: `/sellIntents`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postSellIntentBodyDto
    },
      options);
    }
  


export const getApiPostSellIntentMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPostSellIntent>>, TError,{data: BodyType<PostSellIntentBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiPostSellIntent>>, TError,{data: BodyType<PostSellIntentBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiPostSellIntent>>, {data: BodyType<PostSellIntentBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiPostSellIntent(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiPostSellIntentMutationResult = NonNullable<Awaited<ReturnType<typeof apiPostSellIntent>>>
    export type ApiPostSellIntentMutationBody = BodyType<PostSellIntentBodyDto>
    export type ApiPostSellIntentMutationError = ErrorType<BackendErrorEntity>

    export const useApiPostSellIntent = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPostSellIntent>>, TError,{data: BodyType<PostSellIntentBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiPostSellIntent>>,
        TError,
        {data: BodyType<PostSellIntentBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiPostSellIntentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    